export default "__VITE_ASSET__Usq0AyFB__"